module.exports = __webpack_public_path__ + "img/STORY_app.98265efc.png";